import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SimpleFooter from '../elements/SimpleFooter'
import BankIDSection from '../views/Login/BankIDSection'
import LoginHeader from '../views/Login/LoginHeader'
import LoginMoreInfo from '../views/Login/LoginMoreInfo'
import LoginPerks from '../views/Login/LoginPerks'

type Props = {}

const LoginPageBankID: React.FC<Props> = () => {
	const navigate = useNavigate()

	return (
	<div className="login-wrapper">
		<div className="login-header-wrapper">
			<div className="login-inner Row">
				<LoginHeader />
			</div>
		</div>

		<div className="login-inner Row">
			
			<BankIDSection />
			<LoginPerks />
			<LoginMoreInfo />
		</div>

		<SimpleFooter />
		
	</div>
	)
}

export default LoginPageBankID
